import React from "react";
import "./LoadingState.css";

interface LoadingStateProps {
  progress: number;
}

const LoadingState: React.FC<LoadingStateProps> = ({ progress }) => {
  return (
    <div className="loading-state">
      <div className="loading-animation">
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <h3>Designing...</h3>
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${(progress / 6) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};

export default LoadingState;
